import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { PlanCard } from "@/pages/particular-signup/select_plan/plans";
import EmbeddedCheckoutComponent from "@/pages/particular-signup/select_plan/EmbeddedCheckout";
import { useNavigate } from "react-router";
import { usePostHog } from "posthog-js/react";

const OWNER_PLANS = [
  {
    id: "pro-enterprise",
    name: "PRO ENTERPRISE",
    price: "$2,400/mes",
    duration: "Suscripción mensual",
    type: "Inmobiliaria",
    title: "Publica propiedades sin límite",
    headerBg: "bg-black",
    headerTextColor: "text-white",
    isPopular: true,
    features: [
      { text: "5 usuarios", included: true },
      { text: "15 destacados", included: true },
      { text: "App Casas y Terrenos PRO", included: true },
      { text: "Fichas técnicas de propiedades", included: true },
      { text: "Reportes", included: true },
      { text: "Micrositio con buscador propio", included: true },
      { text: "Conexión a CRMs", included: true },
    ],
    idPlan: "pro-enterprise",
    priceId: import.meta.env.VITE_PUBLIC_ILIMITADO || "price_1SnkzlHGBw2VKdDPbI1VZsw4",
  },
  {
    id: "pro-50",
    name: "PRO 50",
    price: "$1,580/mes",
    duration: "Suscripción mensual",
    type: "Inmobiliaria",
    title: "50 Propiedades",
    headerBg: "bg-[#5CD495]",
    headerTextColor: "text-black",
    features: [
      { text: "4 usuarios", included: true },
      { text: "8 destacados", included: true },
      { text: "App Casas y Terrenos PRO", included: true },
      { text: "Fichas técnicas de propiedades", included: true },
      { text: "Reportes", included: true },
      { text: "Micrositio con buscador propio", included: true },
      { text: "Conexión a CRMs", included: true },
    ],
    idPlan: "pro-50",
    priceId: import.meta.env.VITE_PUBLIC_PRO_50 || "price_1SnlrSHGBw2VKdDPZm1YFKBI",
  },
  {
    id: "pro-mini-10",
    name: "PRO MINI 10",
    price: "$990/mes",
    duration: "Suscripción mensual",
    type: "Inmobiliaria",
    title: "10 Propiedades",
    headerBg: "bg-[#CAA9F5]",
    headerTextColor: "text-black",
    features: [
      { text: "1 usuario", included: true },
      { text: "2 destacados", included: true },
      { text: "App Casas y Terrenos PRO", included: true },
      { text: "Fichas técnicas de propiedades", included: true },
      { text: "Reportes", included: true },
      { text: "Micrositio con buscador propio", included: true },
      { text: "Conexión a CRMs", included: false },
    ],
    idPlan: "pro-mini-10",
    priceId: import.meta.env.VITE_PUBLIC_MINI_10 || "price_1SnlpgHGBw2VKdDPe81SunXU",
  },
  {
    id: "pro-mini-5",
    name: "PRO MINI 5",
    price: "$550/mes",
    duration: "Suscripción mensual",
    type: "Inmobiliaria",
    title: "5 Propiedades",
    headerBg: "bg-[#CAA9F5]",
    headerTextColor: "text-black",
    features: [
      { text: "1 usuario", included: true },
      { text: "1 destacado", included: true },
      { text: "App Casas y Terrenos PRO", included: true },
      { text: "Fichas técnicas de propiedades", included: true },
      { text: "Reportes", included: false },
      { text: "Micrositio con buscador propio", included: false },
      { text: "Conexión a CRMs", included: false },
    ],
    idPlan: "pro-mini-5",
    priceId: import.meta.env.VITE_PUBLIC_MINI || "price_1SnlklHGBw2VKdDPhWB5dMuS",
  },
  {
    id: "pro-gratis",
    name: "PRO Gratis",
    price: "Gratis",
    duration: "Prueba sin costo",
    type: "Gratis",
    title: "0 Propiedades",
    headerBg: "bg-gray-200",
    headerTextColor: "text-gray-800",
    features: [
      { text: "1 usuario", included: true },
      { text: "App Casas y Terrenos PRO", included: true },
      { text: "Reportes", included: false },
      { text: "Micrositio con buscador propio", included: false },
      { text: "Conexión a CRMs", included: false },
    ],
    idPlan: "pro-gratis",
    priceId: null,
  },
];

export default function SelectPlan({ selectedPlanId }) {
  const navigate = useNavigate();
  const posthog = usePostHog();
  const defaultPlan = selectedPlanId || "pro-enterprise";
  const [showCheckout, setShowCheckout] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(defaultPlan);
  const getSelectedPriceId = () => {
    const plan = OWNER_PLANS.find((p) => p.idPlan === selectedPlan);
    return plan ? plan.priceId : null;
  };
  useEffect(() => {
    setSelectedPlan(selectedPlanId || "pro-enterprise");
  }, [selectedPlanId]);

  const handleBackToPlans = () => {
    setShowCheckout(false);
  };

  return (
    <>
      {showCheckout ? (
        <div className="w-full flex items-center justify-center">
          <EmbeddedCheckoutComponent
            key={selectedPlan}
            priceId={getSelectedPriceId()}
            onBack={handleBackToPlans}
          />
        </div>
      ) : (
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-4 lg:px-16 py-10">
          <h2 className="text-2xl font-semibold mb-6 text-center">Elige un plan para comenzar</h2>
          <div className="grid gap-6 justify-items-center grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {OWNER_PLANS.map((plan) => (
              <PlanCard
                key={plan.id}
                plan={plan}
                planType="owner"
                selectedPlan={selectedPlan}
                onSelectPlan={(e) => {
                  setSelectedPlan(e);
                  if (posthog) {
                    posthog.capture("Signup - Pro", {
                      step: 3,
                      stepName: "plan_selected",
                      plan: e,
                    });
                  }
                  if (e === "pro-gratis") {
                    navigate("/inicio");
                  } else {
                    setShowCheckout(true);
                  }
                }}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
}

SelectPlan.propTypes = {
  selectedPlanId: PropTypes.string,
};
